import { createAsyncThunk } from "@reduxjs/toolkit";

import { coreStorageAPIs } from "../../../services/api/magnifi/storageAPIs";

export const getCoreStorageList = createAsyncThunk("core/storage/getCoreStorageList", async (payload) => {
  try {
    const response = await coreStorageAPIs.getCoreStorageList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const createCoreStorage = createAsyncThunk("core/storage/createCoreStorage", async (payload) => {
  try {
    const response = await coreStorageAPIs.createCoreStorage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const updateCoreStorage = createAsyncThunk("core/storage/updateCoreStorage", async (payload) => {
  try {
    const response = await coreStorageAPIs.updateCoreStorage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const deleteCoreStorage = createAsyncThunk("core/storage/deleteCoreStorage", async (payload) => {
  try {
    const response = await coreStorageAPIs.deleteCoreStorage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});
